import React from "react";
import { Card, CardBody, Col, Form, Label, Row } from "reactstrap";
import { Search } from "lucide-react";
import { LoadingButton } from "../components/LoadingButton";
import { PayorSelector } from "../components/inputs/PayorSelector";
import { RemotePaginateSelector } from "../components/inputs/RemotePaginateSelector";

export const CoverageSearchForm = ({ payorIds, setPayorIds, procedureCodes, setProcedureCodes, onSearch, loading }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    onSearch();
  };

  return (
    <Card className="mb-4">
      <CardBody>
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={5}>
              <Label for="coverage-payor">Payors</Label>
              <PayorSelector inputId="coverage-payor" value={payorIds} onChange={setPayorIds} isMulti isClearable />
            </Col>
            <Col md={5}>
              <Label for="coverage-procedure-code">Procedure Codes</Label>
              <RemotePaginateSelector
                inputId="coverage-procedure-code"
                resourceUrl="/coverages/procedure_codes.json"
                dataKey="resources"
                valueKey="code"
                labelKey="code"
                value={procedureCodes}
                onChange={setProcedureCodes}
                isMulti
                isClearable
              />
            </Col>
            <Col md={2} className="d-flex align-items-end">
              <LoadingButton
                color="primary"
                type="submit"
                className="w-100"
                disabled={!payorIds.length}
                loading={loading}
                loadingLabel="Searching..."
                icon={<Search />}
              >
                Search
              </LoadingButton>
            </Col>
          </Row>
          {!payorIds.length && <small className="text-muted">Select at least one payor to search coverages</small>}
        </Form>
      </CardBody>
    </Card>
  );
};
